import React from 'react'
import {Layout} from "../components";
import styles from "../styles/Home.module.scss"
import strategicConsulting from "../images/Services/Strategic Consulting Package.png"
import dataAnalytics from "../images/Services/Data Analytics and Insights Package.png"
import digitalTransformation from "../images/Services/Digital Transformation Package.png"
import innovationAcceleraton from "../images/Services/Innovation Acceleration Package.png"
import mktEntry from "../images/Services/Market Entry Package.png"
import productDevelopment from "../images/Services/Product Development Package.png"
import trainingDev from "../images/Services/Training and Skill Development Package.png"
import lineage_explaination from "../images/lineage_explaination.png"
import {useWindowSize} from "../utility/useLayoutEffect";


const Services = () => {

    const [width] = useWindowSize()

    return (<Layout classes={styles.body}>


        <h3>
            Our Services
        </h3>
        <div className='container'>
            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner} ${styles.reverse}`}>
                    <div className={`${styles.goalsItem1} ${styles.reverse}`}>
                        <img src={strategicConsulting} alt='Strategic Consulting'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Strategic Consulting
                            </h3>
                            <ul>
                                <li>In-depth analysis of your business challenges and goals</li>
                                <li>Development of tailored strategies to drive growth and profitability</li>
                                <li>Market research and competitive analysis to identify opportunities</li>
                                <li>Implementation support and performance monitoring</li>
                                <li>Our Extensive industry knowledge, experience in enterprise and open source
                                    stack enables us to provide the best value </li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner}`}>
                    <div className={`${styles.goalsItem1}`}>
                        <img src={productDevelopment} alt='Product Development'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Product Development
                            </h3>
                            <ul>
                                <li>Concept ideation and validation to bring your ideas to life</li>
                                <li>Full product lifecycle management, from design to launch</li>
                                <li>User experience (UX) and user interface (UI) design services</li>
                                <li>Agile development methodologies for rapid iteration and delivery</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner} ${styles.reverse}`}>
                    <div className={`${styles.goalsItem1} ${styles.reverse}`}>
                        <img src={digitalTransformation} alt='Digital Transformation'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Digital Transformation
                            </h3>
                            <ul>
                                <li>Assessment of your digital readiness and identification of transformation opportunities</li>
                                <li>Development of a comprehensive digital strategy and roadmap</li>
                                <li>Implementation of cutting-edge technologies such as cloud computing, AI, and IoT</li>
                                <li>Change management support to ensure a smooth transition</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner}`}>
                    <div className={`${styles.goalsItem1}`}>
                        <img src={mktEntry} alt='Market Entry'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Market Entry
                            </h3>
                            <ul>
                                <li>Market research and analysis to identify target markets and customer segments</li>
                                <li>Competitive landscape assessment and positioning strategies</li>
                                <li>Localization and cultural adaptation services for successful market entry</li>
                                <li>Sales and distribution channel setup and optimization</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner} ${styles.reverse}`}>
                    <div className={`${styles.goalsItem1} ${styles.reverse}`}>
                        <img src={innovationAcceleraton} alt='Innovation Acceleration'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Innovation Acceleration
                            </h3>
                            <ul>
                                <li>Facilitation of ideation workshops and innovation labs</li>
                                <li>Product prototyping and MVP (Minimum Viable Product) development</li>
                                <li>Design thinking methodologies for customer-centric innovation</li>
                                <li>Collaboration and partnership opportunities with startups and industry disruptors</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner}`}>
                    <div className={`${styles.goalsItem1}`}>
                        <img src={dataAnalytics} alt='Data Analytics and Insights'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Data Analytics and Insights
                            </h3>
                            <ul>
                                <li>Data-driven decision-making through advanced analytics and visualization</li>
                                <li>Customer segmentation and behavior analysis for targeted marketing</li>
                                <li>Predictive modeling and forecasting to optimize business performance</li>
                                <li>Data governance and privacy consulting for regulatory compliance</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={width < 700 ? {marginTop:'60px'} : {}} className={styles.goals}>
                <div className={`${styles.goalsInner} ${styles.reverse}`}>
                    <div className={`${styles.goalsItem1} ${styles.reverse}`}>
                        <img src={trainingDev} alt='Training and Skill Development'/>
                    </div>
                    <div className={styles.goalsItem2}>
                        <div className={styles.content}>
                            <h3>Training and Skill Development
                            </h3>
                            <ul>
                                <li>Customized training programs for your team's professional development</li>
                                <li>Workshops and seminars on industry trends, best practices, and emerging technologies</li>
                                <li>Training on SAP Portfolio products and services</li>
                                <li>Enablement trainings for performance monitoring, security, operations and quality of service</li>
                                <li>Agile and project management training for efficient project execution</li>
                            </ul>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={() => window.location.href= 'contactus' }>Contact Us
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/*<div className={styles.goals}>

            <div className={`${styles.goalsInner} ${styles.reverse}`} style={{background: 'transparent'}}>
                <div className={styles.goalsItem1}>
                    <div className={styles.content}>
                        <img alt={'realtime'} src={gear}/>
                        <h6>Real-Time Interaction</h6>
                        <p>What is the use of a model which takes time in giving results. Our App Architecture and Desing Strategy ensures that our apps and the API models they rely on can scale and meet your real time interactivity needs </p>
                    </div>
                    <div className={styles.content}>
                        <img  alt={'secure data'} src={secure_data}/>
                        <h6>Advanced Annotations</h6>
                        <p>Advanced annotations helps our designers, developers and users alike in getting the most value from the application data, be it transactional or master. Data can be quickly annotated and used for driving value across different usecases</p>
                    </div>
                    <div className={styles.content}>
                        <img alt={'ai-ml'} src={aiml}/>
                        <h6>Manage Your Datasets</h6>
                        <p>Data is the new oil and if not managed properly can cause sever litigation's and monitory issues. We provide spacial care in identifying the data ownership across applications, data processors and controllers. </p>
                    </div>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>Accelerate the development of your AI applications.</h5>
                        <p>Lots of things can go wrong when building an AI driven application. This could be as simple as poor data pipeline design to as big as completely misunderstanding the problem space and building incorrect domain modeling and data strategy. The key for such applications to be successful  is correctly defining the domain model.
                        </p>
                    </div>

                </div>
            </div>
        </div>*/}
        <div className={styles.goals}>

            <div className={styles.goalsInner}>
                <div className={styles.goalsItem1}>
                    <img alt={'linear'} src={lineage_explaination}/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>We Are you Partners throughout your cloud journey
                        </h5>
                        <p>
                            We help you design and implement an optimal architecture for the cloud to meet your current and future needs leveraging proven frameworks, best practices, and leading technologies.

                            Whether you could use some expertise for fine-tuning your current architecture, or you need assistance with a complete overhaul, we’re here to help.

                            Our team of experienced Enterprise Architects, strategists, designers, and builders help companies navigate the chaos, improve performance, and achieve their visions.
                        </p>
                    </div>
                </div>
            </div>

        </div>

        {/* <h3>
            Enterprise Consultancy Services
        </h3>
        <div className={styles.goals}>
            <div className={`${styles.goalsInner}`}>
                <div className={styles.goalsItem1}>
                    <img src={arch_consultancy} alt='consultancy'/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>Enterprise microcosm</h5>
                        <p>We review an organisation's existing landscape to determine whether all its artefacts
                            interact and operate smoothly to deliver a reliable, integrated, scalable and secure system.
                            Our comprehensive evaluation helps us identify the inadequacies preventing your EA from
                            achieving its planned objectives and provides you with a roadmap to suitably overcome those
                            shortcomings.
                        </p>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <button onClick={() => window.location.href= 'contactus' }>Evaluate & strengthen EA with Microcosm
                            </button>
                        </div>
                    </div>
                    <div className={styles.content}>
                        <h5>Enterprise macrocosm</h5>
                        <p>Under this service, along with assessing whether your internal business management set-up
                            aligns with your planned objectives, we also do a thorough analysis of the emerging
                            technologies in the market and the best practices that are specific to your field. This
                            enables us to recommend the steps you need to take to get ahead of the competition and
                            establish your company as an industry leader.
                        </p>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <button onClick={() => window.location.href= 'contactus' }>Master your domain with Macrocosm
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>*/}


        <section style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent:"center", alignItems:"center"}}>
            <h3>We prioritise data safety management.</h3>
            <div className={styles.cardListing}>
                <div className={styles.card}>
                    <div className={styles.details}>
                        <h5>Data privacy and security</h5>
                        <p>We use the most reliable systems, guidelines and technologies to protect your data from
                            theft, damage, loss or unauthorised access. All our offerings have appropriate controls to
                            ensure that your information's privacy and security is never compromised.
                        </p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.details}>
                        <h5>Data controller and data processor</h5>
                        <p>When you avail of any of our products, you are responsible for the data you collect through
                            it. As the Data Controller, you decide the purpose for which the information is collected
                            and used. For all the solutions we provide, we, Cosmoneural, are the Data Processor unless
                            stated otherwise.</p>
                    </div>
                </div>
            </div>
        </section>
        {/*<div className={styles.rating}>
            <h4>“The best experience I’ve ever had.”</h4>
            <div className={styles.ratingInner}>
                <div className={styles.user}>
                    <span className={styles.number}>
                        4.9/5
                    </span>
                    <span className={styles.image}>
                        <img src="https://media-exp1.licdn.com/dms/image/C5603AQHduOBH54795A/profile-displayphoto-shrink_400_400/0/1607837810338?e=1643846400&v=beta&t=31qlDr81a7nHzL6Sw84fCEOvcsKaq-NIoRbwkWscBf4"/>
                    </span>
                    <span className={styles.name}>
                    Abhay Phougat
                </span>
                </div>
                <div className={styles.content}>
                    <h6>Cosmoneural was phenomenal!</h6>
                    <p>
                        I had the opportunity to work with Abhay for a short period. During this time, I observed that he was very quick in grasping business and product requirements, understanding the as-is and magnitude of change involved. As he is strong in his fundamentals, he simplifies the problems and comes up with a good, scalable solution using the right kind of technology that is required. He is someone who is hands-on and always has the big picture in mind. I look forward to working with him again.
                    </p>
                    <img style={{width:"180px", height:"31px", marginTop:"20px"}} src={stars}/>
                </div>
            </div>
            <div style={{display: 'flex',width: "100%", marginTop:"20px",justifyContent: 'center', alignItems: 'center'}}>
                    <span style={{padding: "15px", height:"41px", width: "42px", display: "flex", justifyContent: "center", alignItems:"center", border: "1.5px solid #F0F0F0", boxSizing: "border-box"}}>
                    <img src={arrowLeft}/>
                </span>
                <span style={{transform: "rotate(180deg)",padding: "15px", height:"41px", width: "42px",display: "flex", marginLeft: '20px',justifyContent: "center", alignItems:"center",border: "1.5px solid #F0F0F0", boxSizing: "border-box"}}>
                    <img src={arrowLeft}/></span>
            </div>
        </div>*/}
        <div className={styles.demo}>
            <div className={styles.sendContainer}>
                <h5>How may we help you?</h5>
                {/*<div className={styles.send}><input type='email'/> <span> <img src={send} alt={"send"}/> </span></div>*/}
                <div className={styles.buttonContainer}>
                    <button className={styles.contactUs} onClick={() => window.location.href= 'contactus' }>
                        Cosmoneural products
                    </button>
                    <button className={styles.contactUs} style={{marginLeft: '20px'}} onClick={() => window.location.href= 'contactus' }>
                        EA consultancy services
                    </button>
                </div>
            </div>
        </div>

    </Layout>)
}

export default Services;
